"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useProductParameterGroupTypesServiceCallAll;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _useServiceCallCodeListAll = _interopRequireDefault(require("@sprinx/react-api-client/useServiceCallCodeListAll"));

var _useResolveServiceActionName = _interopRequireDefault(require("@sprinx/react-api-client/useResolveServiceActionName"));

var _useCodeList3 = _interopRequireDefault(require("@sprinx/react-api-client/useCodeList"));

var _useDefaults = _interopRequireDefault(require("@sprinx/react-hooks/useDefaults"));

var _useProductsContext2 = _interopRequireDefault(require("../useProductsContext"));

function useProductParameterGroupTypesServiceCallAll(callOptions, cacheHook, cacheKey, codeListOptions) {
  var _useProductsContext = (0, _useProductsContext2.default)(),
      clientCode = _useProductsContext.clientCode,
      serviceNames = _useProductsContext.serviceNames;

  var apiCall = (0, _useServiceCallCodeListAll.default)((0, _useDefaults.default)(callOptions, {
    clientCode: clientCode
  }), (0, _useResolveServiceActionName.default)(null, 'v1.productParameterGroupTypes.list', serviceNames));

  var _useCodeList = (0, _useCodeList3.default)(codeListOptions, cacheKey || 'products_parameterGroups', apiCall, cacheHook, []),
      _useCodeList2 = (0, _slicedToArray2.default)(_useCodeList, 5),
      searchable = _useCodeList2[0],
      localizedSearch = _useCodeList2[1],
      rawData = _useCodeList2[2],
      loading = _useCodeList2[3],
      reloadData = _useCodeList2[4];

  return [searchable, localizedSearch, rawData, loading, reloadData];
}